/* =========================================================
   Fitters Footwear – Kundenumfrage (Frontend-Logik)
   - Schritt-Navigation + Fortschrittsbalken
   - Validierung (Pflichtfelder, E-Mail, DSGVO)
   - 5-Sterne / NPS / Single / Multi / Freitext
   - Bedingte (Folge-)Fragen
   - Autosave (localStorage)
   - E-Mail-Prefill via URL-Parameter ?email=
   - Vorab-Prüfung & Absenden an Google Apps Script
   ========================================================= */
(function () {
  "use strict";

  var root = document.getElementById("kq-root");
  if (!root) return;

  var endpoint = (root.getAttribute("data-endpoint") || "").trim();
  var STORAGE_KEY = "fitters_kundenumfrage_v1";
  var SUBMITTED_KEY = "fitters_kundenumfrage_done_v1";

  // SEO: noindex zusätzlich per JS absichern (Fallback zum head-Eintrag)
  if (!document.querySelector('meta[name="robots"][content*="noindex"]')) {
    var m = document.createElement("meta");
    m.name = "robots";
    m.content = "noindex, nofollow";
    document.head.appendChild(m);
  }

  var form = root.querySelector(".kq-form");
  var steps = Array.prototype.slice.call(root.querySelectorAll(".kq-step"));
  var totalQuestions = 17; // angezeigte Fragenanzahl im Label
  var startBtn = root.querySelector("[data-kq-start]");
  var backBtn = root.querySelector("[data-kq-back]");
  var nextBtn = root.querySelector("[data-kq-next]");
  var submitBtn = root.querySelector("[data-kq-submit]");
  var errorBox = root.querySelector("[data-kq-error]");
  var autosaveNote = root.querySelector("[data-kq-autosave]");
  var progress = root.querySelector("[data-kq-progress]");
  var progressBar = root.querySelector("[data-kq-progress-bar]");
  var progressTrack = root.querySelector(".kq__progress-track");
  var progressLabel = root.querySelector("[data-kq-progress-label]");

  var current = 0;
  var submitting = false;

  /* ---------- Screen-Steuerung ---------- */
  function showScreen(name) {
    root.querySelectorAll("[data-screen]").forEach(function (el) {
      el.hidden = el.getAttribute("data-screen") !== name;
    });
    if (name === "form") {
      progress.hidden = false;
    } else {
      progress.hidden = true;
    }
    if (name !== "form") {
      try { root.scrollIntoView({ behavior: "smooth", block: "start" }); } catch (e) {}
    }
  }

  /* ---------- Bedingte Felder ---------- */
  function refreshConditionals() {
    root.querySelectorAll("[data-show-if-name]").forEach(function (cond) {
      var name = cond.getAttribute("data-show-if-name");
      var want = cond.getAttribute("data-show-if-value");
      var match = false;
      root.querySelectorAll('[name="' + name + '"]').forEach(function (inp) {
        if (inp.checked && inp.value === want) match = true;
      });
      cond.hidden = !match;
    });
  }

  /* ---------- Schritt-Navigation ---------- */
  function goToStep(i, focus) {
    if (i < 0) i = 0;
    if (i > steps.length - 1) i = steps.length - 1;
    current = i;
    steps.forEach(function (s, idx) { s.hidden = idx !== current; });

    backBtn.hidden = current === 0;
    var isLast = current === steps.length - 1;
    nextBtn.hidden = isLast;
    submitBtn.hidden = !isLast;

    updateProgress();
    hideError();
    if (focus !== false) {
      var f = steps[current].querySelector("input, textarea, button, [tabindex]");
      if (f) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
      try { steps[current].scrollIntoView({ behavior: "smooth", block: "center" }); } catch (e) {}
    }
  }

  function updateProgress() {
    var pct = Math.round(((current + 1) / steps.length) * 100);
    progressBar.style.width = pct + "%";
    if (progressTrack) progressTrack.setAttribute("aria-valuenow", String(pct));
    var qNum = Math.min(current + 1, totalQuestions);
    if (current >= totalQuestions) {
      progressLabel.textContent = "Letzter Schritt";
    } else {
      progressLabel.textContent = "Frage " + qNum + " von " + totalQuestions;
    }
  }

  /* ---------- Validierung ---------- */
  function stepValid(step) {
    var required = step.getAttribute("data-required") === "true";
    var type = step.getAttribute("data-type");
    var name = step.getAttribute("data-name");

    if (type === "final") {
      var email = form.querySelector('[name="email"]');
      var dsgvo = form.querySelector('[name="dsgvo"]');
      var consentWrap = dsgvo ? dsgvo.closest(".kq-consent") : null;
      var ok = true;
      if (!email || !isValidEmail(email.value)) {
        if (email) email.classList.add("kq-input--error");
        ok = false;
      } else {
        email.classList.remove("kq-input--error");
      }
      if (!dsgvo || !dsgvo.checked) {
        if (consentWrap) consentWrap.classList.add("kq-consent--error");
        ok = false;
      } else if (consentWrap) {
        consentWrap.classList.remove("kq-consent--error");
      }
      return ok ? true : "Bitte gib eine gültige E-Mail-Adresse an und bestätige die Datenschutzhinweise.";
    }

    if (!required) return true;

    if (type === "single" || type === "stars" || type === "nps") {
      var checked = step.querySelector('[name="' + name + '"]:checked');
      return checked ? true : "Bitte wähle eine Option aus, um fortzufahren.";
    }
    if (type === "multi") {
      var any = step.querySelector('[name="' + name + '"]:checked');
      return any ? true : "Bitte wähle mindestens eine Option aus.";
    }
    if (type === "text") {
      var ta = step.querySelector("textarea, input[type=text]");
      return (ta && ta.value.trim()) ? true : "Bitte fülle dieses Feld aus.";
    }
    return true;
  }

  function isValidEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((v || "").trim());
  }

  /* ---------- Fehler ---------- */
  function showError(msg) {
    errorBox.textContent = msg;
    errorBox.hidden = false;
    try { errorBox.scrollIntoView({ behavior: "smooth", block: "center" }); } catch (e) {}
  }
  function hideError() { errorBox.hidden = true; errorBox.textContent = ""; }

  /* ---------- Datensammlung ---------- */
  function collectData() {
    var data = {};
    var multi = {};
    var inputs = form.querySelectorAll("input, textarea, select");
    inputs.forEach(function (inp) {
      var n = inp.name;
      if (!n) return;
      if (inp.type === "checkbox") {
        if (n === "dsgvo") { data.dsgvo = inp.checked ? "Ja" : "Nein"; return; }
        if (inp.checked) { (multi[n] = multi[n] || []).push(inp.value); }
        return;
      }
      if (inp.type === "radio") {
        if (inp.checked) data[n] = inp.value;
        return;
      }
      data[n] = inp.value.trim();
    });
    Object.keys(multi).forEach(function (k) { data[k] = multi[k].join(", "); });

    // "Sonstige"-Freitext an Wettbewerber anhängen
    if (data.wettbewerber && /Sonstige/.test(data.wettbewerber) && data.wettbewerber_sonstige) {
      data.wettbewerber = data.wettbewerber.replace(/Sonstige/, "Sonstige: " + data.wettbewerber_sonstige);
    }
    data.page_url = window.location.href;
    return data;
  }

  /* ---------- Autosave ---------- */
  var saveTimer = null;
  function autosave() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(collectData()));
        if (autosaveNote) {
          autosaveNote.hidden = false;
          autosaveNote.style.opacity = "1";
          setTimeout(function () { autosaveNote.style.opacity = "0.5"; }, 1200);
        }
      } catch (e) {}
    }, 350);
  }

  function restore() {
    var raw;
    try { raw = localStorage.getItem(STORAGE_KEY); } catch (e) { return; }
    if (!raw) return;
    var data;
    try { data = JSON.parse(raw); } catch (e) { return; }
    Object.keys(data).forEach(function (k) {
      var val = data[k];
      var fields = form.querySelectorAll('[name="' + cssEscape(k) + '"]');
      if (!fields.length) return;
      fields.forEach(function (f) {
        if (f.type === "radio") {
          f.checked = f.value === val;
        } else if (f.type === "checkbox") {
          if (k === "dsgvo") { f.checked = val === "Ja"; }
          else { f.checked = String(val).split(", ").indexOf(f.value) !== -1; }
        } else {
          f.value = val;
        }
      });
    });
    refreshConditionals();
    syncStars();
  }

  function cssEscape(s) { return String(s).replace(/"/g, '\\"'); }

  /* ---------- Sterne-Anzeige (JS-gesteuerte Füllung) ---------- */
  function paintStars(group, n) {
    group.querySelectorAll(".kq-stars__item").forEach(function (it) {
      var v = parseInt(it.getAttribute("data-kq-star"), 10);
      var icon = it.querySelector(".kq-stars__icon");
      if (icon) icon.classList.toggle("is-on", v <= n);
    });
  }
  function selectedStar(group) {
    var c = group.querySelector("input:checked");
    return c ? parseInt(c.value, 10) : 0;
  }
  function syncStars() {
    root.querySelectorAll(".kq-stars").forEach(function (group) {
      var val = selectedStar(group);
      var out = group.querySelector("[data-kq-stars-value]");
      if (out) out.textContent = val ? val + "/5" : "";
      paintStars(group, val);
    });
  }
  function setupStars() {
    root.querySelectorAll(".kq-stars").forEach(function (group) {
      group.querySelectorAll(".kq-stars__item").forEach(function (it) {
        it.addEventListener("mouseenter", function () {
          paintStars(group, parseInt(it.getAttribute("data-kq-star"), 10));
        });
      });
      group.addEventListener("mouseleave", function () {
        paintStars(group, selectedStar(group));
      });
    });
  }

  /* ---------- Vorab-Prüfung (E-Mail aus URL) ---------- */
  function precheckEmail(email) {
    if (!endpoint || endpoint.indexOf("PASTE_") === 0) return Promise.resolve(false);
    var url = endpoint + (endpoint.indexOf("?") === -1 ? "?" : "&") + "email=" + encodeURIComponent(email);
    return fetch(url, { method: "GET" })
      .then(function (r) { return r.json(); })
      .then(function (j) { return !!(j && j.participated); })
      .catch(function () { return false; });
  }

  /* ---------- Absenden ---------- */
  function setSubmitting(on) {
    submitting = on;
    submitBtn.disabled = on;
    submitBtn.classList.toggle("kq-btn--loading", on);
    backBtn.disabled = on;
  }

  function submit() {
    if (submitting) return;
    // Vollständige Validierung aller Pflichtschritte
    for (var i = 0; i < steps.length; i++) {
      var res = stepValid(steps[i]);
      if (res !== true) {
        goToStep(i);
        showError(typeof res === "string" ? res : "Bitte fülle dieses Feld aus.");
        return;
      }
    }
    hideError();

    if (!endpoint || endpoint.indexOf("PASTE_") === 0) {
      showError("Konfigurationsfehler: Die Backend-URL ist noch nicht hinterlegt. Bitte kontaktiere den Shop-Betreiber.");
      return;
    }

    var payload = collectData();
    setSubmitting(true);

    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 25000);

    fetch(endpoint, {
      method: "POST",
      // text/plain vermeidet CORS-Preflight gegenüber Apps Script
      headers: { "Content-Type": "text/plain;charset=utf-8" },
      body: JSON.stringify(payload),
      signal: controller.signal
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        clearTimeout(timeout);
        setSubmitting(false);
        if (!j || j.status === "error") {
          showError((j && j.message) || "Es ist ein Fehler aufgetreten. Bitte versuche es erneut.");
          return;
        }
        if (j.status === "duplicate") {
          try { localStorage.setItem(SUBMITTED_KEY, "1"); } catch (e) {}
          showScreen("duplicate");
          return;
        }
        // Erfolg
        try {
          localStorage.removeItem(STORAGE_KEY);
          localStorage.setItem(SUBMITTED_KEY, "1");
        } catch (e) {}
        var codeEl = root.querySelector("[data-kq-voucher-code]");
        if (codeEl) codeEl.textContent = j.voucher || "(per E-Mail gesendet)";
        showScreen("success");
      })
      .catch(function (err) {
        clearTimeout(timeout);
        setSubmitting(false);
        if (err && err.name === "AbortError") {
          showError("Zeitüberschreitung. Bitte prüfe deine Verbindung und versuche es erneut.");
        } else {
          showError("Verbindung fehlgeschlagen. Bitte versuche es in einem Moment erneut.");
        }
      });
  }

  /* ---------- Gutschein kopieren ---------- */
  var copyBtn = root.querySelector("[data-kq-copy]");
  if (copyBtn) {
    copyBtn.addEventListener("click", function () {
      var code = root.querySelector("[data-kq-voucher-code]");
      if (!code) return;
      var txt = code.textContent.trim();
      if (navigator.clipboard) {
        navigator.clipboard.writeText(txt).then(function () {
          copyBtn.textContent = "✓ Kopiert";
          setTimeout(function () { copyBtn.textContent = "Code kopieren"; }, 2000);
        });
      }
    });
  }

  /* ---------- Event-Bindung ---------- */
  if (startBtn) startBtn.addEventListener("click", function () {
    showScreen("form");
    goToStep(0);
  });
  if (nextBtn) nextBtn.addEventListener("click", function () {
    var res = stepValid(steps[current]);
    if (res !== true) { showError(typeof res === "string" ? res : "Bitte fülle dieses Feld aus."); return; }
    goToStep(current + 1);
  });
  if (backBtn) backBtn.addEventListener("click", function () { goToStep(current - 1); });
  if (submitBtn) submitBtn.addEventListener("click", submit);
  form.addEventListener("submit", function (e) { e.preventDefault(); submit(); });

  // Bei Auswahl: nur Anzeige/Conditionals aktualisieren & speichern.
  // Der Schrittwechsel erfolgt ausschließlich über den "Weiter"-Button.
  form.addEventListener("change", function () {
    refreshConditionals();
    syncStars();
    autosave();
  });
  form.addEventListener("input", autosave);

  /* ---------- Initialisierung ---------- */
  function init() {
    setupStars();
    refreshConditionals();
    restore();
    syncStars();

    // E-Mail aus URL-Parameter vorbefüllen
    var params = new URLSearchParams(window.location.search);
    var emailParam = params.get("email");
    var emailField = form.querySelector('[name="email"]');
    if (emailParam && emailField && !emailField.value) {
      emailField.value = emailParam;
      autosave();
    }

    // Bereits teilgenommen? -> Vorab-Prüfung bei bekannter E-Mail
    if (emailParam && isValidEmail(emailParam)) {
      precheckEmail(emailParam).then(function (done) {
        if (done) showScreen("duplicate");
      });
    }
  }

  init();
})();
